import classnames from 'classnames';
import React, { useCallback } from 'react';
import Modal from 'react-bootstrap/Modal';
import LoadingIndicator from 'v2/common/LoadingIndicator/LoadingIndicator';
import useDatFileForm from 'v2/hooks/useDatFileForm';
import {
  geFileData,
  getSavedFileData,
  onFileSelected,
} from 'v2/utils/fileUtils';
import AddNewFileForm from '../AddNewFileForm/AddNewFileForm';
import { DataFileEntity, DataFileForm } from '../models';
import styles from './dataFileModalForm.module.scss';

interface DataProductModalProps {
  show: boolean;
  onHide: (refreshData?: boolean) => void;
  onChangeFile: (file?: File | undefined) => void;
  selectedFile: File | null;
  data?: DataFileEntity | null;
  className?: string;
}

const DataFileModalForm = ({
  show,
  onHide,
  onChangeFile,
  selectedFile,
  data,
  className = '',
}: DataProductModalProps) => {
  const { errors, handleSubmit, register, onSubmit, isLoading, reset } =
    useDatFileForm(selectedFile, data);
  const onDrop = useCallback(onFileSelected(onChangeFile), [onChangeFile]);
  const fileData = selectedFile
    ? geFileData(selectedFile)
    : getSavedFileData(data);

  const _onSubmit = async (formData: DataFileForm) => {
    await onSubmit(formData);
    _onHide(true);
    reset();
  };

  const _onHide = (refreshData?: boolean) => {
    onHide(refreshData);
  };

  return (
    <Modal
      className={className}
      show={show}
      onHide={() => _onHide()}
      animation={true}
      centered={true}
    >
      <Modal.Header>
        <Modal.Title className="modalTitle">Upload File</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit(_onSubmit)}>
        <Modal.Body>
          <div className={classnames('card-body', styles.modalBody, 'scroll')}>
            <div className="row">
              <div className="col-md-12">
                <AddNewFileForm
                  fileData={fileData}
                  onDrop={onDrop}
                  register={register}
                  errors={errors}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <input
            className="btn-secondary-dark btn btn-secondary"
            type="button"
            value="Cancel"
            onClick={() => _onHide()}
          />
          <button
            className={classnames('btn btn-primary', styles.saveBtn)}
            type="submit"
            disabled={isLoading}
          >
            {isLoading ? (
              <LoadingIndicator className={styles.loadingIndicator} />
            ) : data ? (
              'Save'
            ) : (
              'Add File'
            )}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default DataFileModalForm;
